var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_278",
    "data-name": "Group 278",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.007,
    height: 18.983,
    viewBox: "0 0 19.007 18.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M-692.643,683.489a7.949,7.949,0,0,1,7.992-7.955,7.963,7.963,0,0,1,7.958,8.038,7.971,7.971,0,0,1-8.041,7.914A7.961,7.961,0,0,1-692.643,683.489Zm1.843-.022a6.116,6.116,0,0,0,6.055,6.178,6.134,6.134,0,0,0,6.211-6.074,6.118,6.118,0,0,0-6.086-6.195A6.1,6.1,0,0,0-690.8,683.467Z",
    transform: "translate(692.643 -675.534)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M-618.679,748.544a.93.93,0,0,1-.532.832.837.837,0,0,1-.982-.1c-1.07-1.049-2.136-2.1-3.178-3.181a.851.851,0,0,1,.055-1.188.856.856,0,0,1,1.219-.08c1.077,1.042,2.131,2.109,3.178,3.181A1.736,1.736,0,0,1-618.679,748.544Z",
    transform: "translate(637.686 -730.503)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/Search2.23718ab9e1b72e052f814192705e6f79.svg";
export { ForwardRef as ReactComponent };